<template>
  <vue-page-transition name="fade-in-down">
    <v-content class="db-content">
        <v-card style="top: -60px;" flat>
          <ResearchNotes></ResearchNotes>
        </v-card>
    
    </v-content>
  </vue-page-transition>
</template>

  <script src='https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.13/vue.min.js'></script>
<script src='https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.5/lodash.min.js'></script><script  src="./script.js"></script>

<script>
import ResearchNotes from './ResearchNotes.vue';
export default {
  name: 'Notes',
  components: {
    ResearchNotes,
  },
  data() {
    return {
      scrollInvoked: 0,
      ownerOptions: [
        'John Salinas',
        'Danny Barlavi',
        'David Barlavi',
        'Amelia Lang',
        'Jasmine',
        'Chris',
      ],
      accountOptions: [
        'Retail',
        'Wholesale',
        'Online',
        'eBay CellFunds',
        'eBay eMerchants',
      ],
      paymentType: ['Cash', 'Debit', 'Credit', 'Trade', 'Crypto'],
      invoiceStatus: ['Paid', 'Pending', 'Created', 'Canceled'],
      items: [],
      notesList: [],
      searchKey: '',
      search: '',
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      overlay: false,
      rows: 100,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: new Date(),
      formFields: {
        userName: '',
        noteTitle: '',
        noteDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        note: '',
        noteType: '',
        NoteStatus: '',
      },
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: 'Date',
          value: 'noteDate',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Title',
          value: 'noteTitle',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Note',
          value: 'note',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: 'Type',
          value: 'noteType',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: 'Status',
          value: 'noteStatus',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: true,
          divider: true,
        },
      ],
    };
  },

  mounted() {
    this.getNotesList();
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/notes') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('Title');
        this.startListining();
      }, 2000);
      this.overlay = true;
    });

    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/notes') {
        return;
      }
      console.log(data.msg);
      this.editLead(this.notesList[0]);
    });

    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/notes') {
        return;
      }
      this.search = data.msg;
      this.searchLead(data.msg);
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printLead: function() {
    window.print();
  },

  methods: {
    initialize() {
      this.notesList = [];
    },

    onScroll() {
      this.scrollInvoked++;
    },

    searchNote: async function() {
      console.log(this.search);
      if (!this.search) this.getNotesList();

      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}note-form/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;

      console.log(json);
      this.notesList = json.result;
    },

    getNotesList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}note-form/all`
      );
      const json = await response.json();
      console.log(json);
      this.notesList = json.result;
      this.tableLoader = false;
    },

    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])

      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}note-form/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('Note Created');
        this.getNotesList();
        this.resetForm();
      }, 800);
    },

    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },

    deleteNote: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}note-form/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;

      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getNotesList();
      }, 800);
    },

    editNote: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
    },

    updateNote: async function() {
      this.loading3 = true;

      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}note-form/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getNotesList();
        this.resetForm();
      }, 800);
    },

    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        userName: '',
        noteTitle: '',
        noteDate: '',
        note: '',
        noteType: '',
        NoteStatus: '',
      };
    },

    openForm: function() {
      this.overlay = true;
      this.items = [];
    },

    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 3000);
    },

    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },

    readOutLoud: function(msg) {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;

    },
    fillForm: function(msg) {
      switch (this.currentField) {
        case 0:
          this.formFields.noteTitle = msg;
          this.currentField++;
          break;
        case 1:
          this.formFields.note = msg;
          this.currentField++;
          break;
        case 2:
          this.formFields.noteType = msg;
          this.currentField++;
          break;
        case 3:
          this.formFields.noteStatus = msg;
          this.currentField++;
          break;
      }
      this.currentField++;
      this.navigateField();
    },

    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Title?');
          break;
        case 1:
          this.readOutLoud('Note?');
          break;
        case 2:
          this.readOutLoud('Note Type?');
          break;
        case 3:
          this.readOutLoud('Note Status?');
          break;
      }

      this.startListining();
    },
  },
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
</style>

